import { PayloadAction } from '@reduxjs/toolkit';
import apiTypes from 'src/api/optimalprint-sdk.d';
import { GalleryState } from 'src/store/gallery/types';

const addGalleryImagesReducer = (state: GalleryState, action: PayloadAction<apiTypes.AppBundle.Api.Entity.Photo.V1.IPhoto[]>) => {
  state.images = [...state.images, ...action.payload];
};

export default addGalleryImagesReducer;
